$('[data-post-on-change]').change(function(){
    var target = $('option:selected', this).data('post-value');
    window.location.href = target;
});


// WEBPACK FOOTER //
// ./js/modules/_filter_change.js